// helpers
import { ApiHelper } from 'shared/helpers/api';
import { log } from 'shared/helpers/newRelic';
import { getDomain } from 'shared/helpers/app';

// constants
import { getUrl, ROUTES } from 'shared/api/urls';

// defs
import { IFetchWidgetDataProps } from 'shared/store/widgets/types';

// constants
import { TAG_IDENTIFIER } from 'shared/helpers/newRelic/constants';
import { DEFAULT_COUNTRY, DEFAULT_CURRENCY_CODE } from 'shared/constants';

const domainHeader = getDomain();

interface FetchWidgetByTypeProps {
  productID: string | number;
  widgetType: string;
  widgetAlgo: string;
  pageNumber: string | number;
  catalogTagFilter?: string;
}

export const getWidgetsData = ({ productID, apiConfig, storeId }: IFetchWidgetDataProps): Promise<any> => {

  const url = getUrl(ROUTES.WIDGETS);
  const params = new URLSearchParams('');

  params.set('product_id', productID);

  // set country information to definitely receive data in domestic currency
  params.append('countryCode', DEFAULT_COUNTRY);
  params.append('currency', DEFAULT_CURRENCY_CODE);

  if (apiConfig !== '') {
    params.set('recommendation_json', apiConfig);
  }
  if (storeId) {
    params.set('catalog_tag_filter', storeId);
  }

  return ApiHelper(`${url}?${params.toString()}`, { headers: { domain: domainHeader } }).then(
    (response: Response) => {
      try {
        const data = response.json();
        if (response.ok === false) {
          return Promise.reject({ status: response.status, data });
        }
        return data;
      } catch (e) {
        return Promise.reject({ status: 500 });
      }
    }
  );
};

export const getWidgetsByType = ({
  productID,
  widgetAlgo,
  widgetType,
  pageNumber,
  catalogTagFilter,
}: FetchWidgetByTypeProps) => {
  const url = getUrl(ROUTES.WIDGETS);
  const params = new URLSearchParams('');

  if (!productID) {
    log({ errTitle: 'Invalid Product ID', tags: { [TAG_IDENTIFIER.MODULE]: 'WIDGET_LISTING' } });
    return Promise.reject({ status: 500 });
  }
  // set product id
  params.set('product_id', String(productID));

  // only fetch data relevant to current page
  params.set('recommendation_json', JSON.stringify([{ [widgetType]: widgetAlgo }]));

  // set page number
  params.set('current_page', String(pageNumber));

  // set country information to definitely receive data in domestic currency
  params.append('countryCode', DEFAULT_COUNTRY);
  params.append('currency', DEFAULT_CURRENCY_CODE);

  if (catalogTagFilter) {
    params.set('catalog_tag_filter', catalogTagFilter);
  }

  return ApiHelper(`${url}?${params.toString()}`).then((response: Response) => {
    try {
      if (response.ok === false) {
        return Promise.reject({ status: response.status, data });
      }
      const data = response.json();
      return data;
    } catch (e) {
      return Promise.reject({ status: 500 });
    }
  });
};
